import '../css/ChankangOrder.css'

import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Form, Button, Input, Select, Table, Row, Col, InputNumber, DatePicker, Space, Checkbox, message, Modal, Upload } from 'antd'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosComplete, baseAxiosNoInfo } from '../../../tool/axios'
import { apiPrefix } from '../../../js/config'
import { ngetBase64 } from '../../../js/globalParam'
import moment from 'moment'
import _ from 'lodash'

import zfb from '../../../images/zfb.png'
import wx from '../../../images/wx.png'
import money from '../../../images/money.png'
import pos from '../../../images/pos.png'

const { Column } = Table
const { Option } = Select

const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 12 }
}

const customerFormItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 }
}

export default function CkAddList() {

    const params: { id: string } = useParams()

    const [userData, setUserData] = useState<any>({ customer_name: '', customer_id: '' })
    const [hasVip, setHasVip] = useState<boolean | null>(null)

    const [formRef] = Form.useForm()
    const [formInfoRef] = Form.useForm()
    const [vipInfoRef] = Form.useForm()
    const [customerRef] = Form.useForm()

    const [shouldPay, setShouldPay] = useState<number>()
    const [payNums, setPayNums] = useState<any>({ 1: undefined, 2: undefined, 3: undefined, 4: undefined })

    const [buyList, setBuyList] = useState<any[]>([])
    const [giveList, setGiveList] = useState<any[]>([])
    const [extraList, setExtraList] = useState<any[]>([])

    const [optionData, setOptionData] = useState<any[]>([])
    const [defaultStoreName, setDefaultStoreName] = useState<any[]>([])
    const [storeId, setStoreId] = useState<string>('')

    const [employeeIdAdviser, setEmployeeIdAdviser] = useState<string>('')
    const [employeeIdRecover, setEmployeeIdRecover] = useState<string>('')

    const [customerVisible, setCustomerVisible] = useState<boolean>(false)
    const [customersource, setCustomersource] = useState<any[]>([])

    const [adviseEmployeeList, setAdviseEmployeeList] = useState<any[]>([])
    const [recoverEmployeeList, setRecoverEmployeeList] = useState<any[]>([])

    const [ckSingle, setCkSingle] = useState<any[]>([])
    const [ckMenu, setCkMenu] = useState<any[]>([])

    const [totalPrices, setTotalPrices] = useState<number>(0)
    const [agreementList, setAgreementList] = useState<any[]>([])
    const [payList, setPayList] = useState<any[]>([])

    const [packageItemData, setPackageItemData] = useState<any[]>([])
    const [packageItemVisible, setPackageItemVisible] = useState<boolean>(false)

    const [previewImage, setPreviewImage] = useState<string>('')
    const [visible, setVisible] = useState<boolean>(false)

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }

        setPreviewImage(file.preview)
        setVisible(true)
    }

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e && e.fileList
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    useEffect(() => {
        // 获取订单详情
        baseAxiosNoInfo('/chankang_center/order_list/detail', {
            params: {
                order_id: params.id
            }

        }).then((res: any) => {
            // 初始化选项数据
            initOptionData(res.store_id)

            setStoreId(res.store_id)
            setDefaultStoreName(res.store_name)

            setFormData(res.employee_adviser_list)
            setFormData2(res.employee_recover_list)

            setUserData({
                customer_id: res.customer_id,
                customer_name: res.customer_name,
                customer_phone: res.customer_phone
            })

            vipInfoRef.setFieldsValue({
                customer_phone: res.customer_phone
            })

            // 初始化每个产康项目的项目类型
            if (res.buy_item_list) {
                res.buy_item_list.map((el: any) => {
                    if (el.chankang_item_type_desc == '产康单项') {
                        el.chankang_item_type = '1'
                    } else {
                        el.chankang_item_type = '2'
                    }
                })
            }

            if (res.gift_chankang_item_list) {
                res.gift_chankang_item_list.map((el: any) => {
                    if (el.chankang_item_type_desc == '产康单项') {
                        el.chankang_item_type = '1'
                    } else {
                        el.chankang_item_type = '2'
                    }
                })
            }


            if (res.gift_yuezi_item_list) {
                res.gift_yuezi_item_list.map((el: any) => {
                    if (el.chankang_item_type_desc == '产康单项') {
                        el.chankang_item_type = '1'
                    } else {
                        el.chankang_item_type = '2'
                    }
                })
            }

            setBuyList(res.buy_item_list || [])
            setGiveList(res.gift_chankang_item_list || [])
            setExtraList(res.gift_yuezi_item_list || [])

            // 处理支付方式
            let pay_way = []
            if (res.pay_records) {
                pay_way = res.pay_records.map((el: any) => el.pay_way)

                let p = _.cloneDeep(payNums)
                res.pay_records.map((el: any) => {
                    p[el.pay_way] = el.pay_amount
                })

                setPayNums(p)
            }

            formInfoRef.setFieldsValue({
                deal_date: moment(res.deal_date),
                remark: res.remark,
                actual_pay_amount: res.actually_deal_amount,
                pay_way
            })

            // 初始化图片
            if (res.agreement_pic_list && res.agreement_pic_list.length > 0) {
                formInfoRef.setFieldsValue({
                    agreementList: res.agreement_pic_list.split(',').map((el: any) => {
                        return {
                            url: el, // 回显图片
                            uid: el,
                            response: {
                                data: [el]
                            }
                        }
                    })
                })
            }

            if (res.pay_pic_list && res.pay_pic_list.length > 0) {
                formInfoRef.setFieldsValue({
                    payList: res.pay_pic_list.split(',').map((el: any) => {
                        return {
                            url: el, // 回显图片
                            uid: el,
                            response: {
                                data: [el]
                            }
                        }
                    })
                })
            }
        })
    }, [])

    useEffect(() => {
        // 门店
        baseAxiosNoInfo('/global/store_list').then((res: any) => {
            if (res) {
                setOptionData(res)
            }
        })

        // 客户来源
        baseAxiosNoInfo('/chankang_center/customer_source_list').then((res: any) => {
            if (res) {
                setCustomersource(res)
            }
        })
    }, [])

    useEffect(() => {
        if (formInfoRef.getFieldValue('pay_way') && formInfoRef.getFieldValue('pay_way').length > 0) {
            let num = 0

            formInfoRef.getFieldValue('pay_way').forEach((el: any) => {
                num += ((Number(payNums[el]) * 100) / 100) || 0
            })

            formInfoRef.setFieldsValue({
                actual_pay_amount: num
            })
        }
    }, [payNums])

    // 监听订单总价
    useEffect(() => {
        let prices = 0

        for (let i = 0; i < buyList.length; i++) {
            prices += (buyList[i].count * buyList[i].total_amount)
        }

        let money: any = prices.toFixed(2)
        setTotalPrices(money)
    }, [totalPrices, buyList])

    // 初始化选项数据
    const initOptionData = (value: String) => {
        // 初始化加载默认的 套餐列表
        getStoreItemList(value, 1) // 产康单项
        getStoreItemList(value, 2) // 产康套餐

        getEmployeeList(value, 4)
        getEmployeeList(value, 5)

        baseAxiosNoInfo('/global/employee_list_by_position', {
            params: {
                position_number: 4,
                department_id: value
            }
        }).then((res: any) => {
            setEmpList(res)
        })

        baseAxiosNoInfo('/global/employee_list_by_position', {
            params: {
                position_number: 5,
                department_id: value
            }
        }).then((res: any) => {
            setEmpList2(res)
        })
    }

    // 某组织下面的员工列表 产康师 产康顾问
    const getEmployeeList = (storeId: any, type: any) => {
        baseAxiosNoInfo('/global/employee_list_by_position', { params: { department_id: storeId, position_number: type } }).then((res: any) => {
            if (res) {
                if (type == 5) {
                    setRecoverEmployeeList(res)

                } else {
                    setAdviseEmployeeList(res)
                }
            }
        })
    }

    // 查询门店项目列表
    const getStoreItemList = (value: any, type: any) => {
        baseAxiosNoInfo('/chankang_center/store_item/on_list', { params: { chankang_item_type: type, store_id: value } }).then((res: any) => {
            if (res) {
                if (type == 1) {
                    setCkSingle(res)
                }

                if (type == 2) {
                    setCkMenu(res)
                }
            }
        })
    }

    // 选择门店
    const handleStore = (value: any, option: any) => {
        setStoreId(value)
        setDefaultStoreName(option.children)

        getStoreItemList(value, 1) // 产康单项
        getStoreItemList(value, 2) // 产康套餐
        getEmployeeList(value, 4) // 产康顾问
        getEmployeeList(value, 5) // 产康师
    }

    // 切换项目类型
    const handleSelectProject = (el: any, index: any, type: any, which: any) => {
        if (which == 'buy') {
            let newArr = _.cloneDeep(buyList)
            newArr[index][type] = el

            setBuyList(newArr)
        }

        if (which == 'give') {
            let newArr = _.cloneDeep(giveList)
            newArr[index][type] = el

            setGiveList(newArr)
        }

        if (which == 'extra') {
            let newArr = _.cloneDeep(extraList)
            newArr[index][type] = el

            setExtraList(newArr)
        }
    }

    // 选择套餐
    const handleSelectStore = (el: any, index: any, option: any, type: any, which: any) => {
        if (which == 'buy') {
            let newArr = _.cloneDeep(buyList)
            newArr[index][type] = el
            newArr[index]['item_id'] = option.tab
            newArr[index]['total'] = option.label
            newArr[index]['item_latest_price'] = option.label

            console.log('newArr', newArr)
            setBuyList(newArr)
        }

        if (which == 'give') {
            let newArr = _.cloneDeep(giveList)
            newArr[index][type] = el
            newArr[index]['item_id'] = option.tab
            newArr[index]['item_latest_price'] = option.label

            setGiveList(newArr)
        }

        if (which == 'extra') {
            let newArr = _.cloneDeep(extraList)
            newArr[index][type] = el
            newArr[index]['item_id'] = option.tab
            newArr[index]['item_latest_price'] = option.label

            setExtraList(newArr)
        }
    }

    // 处理次数
    const handleCount = (el: any, index: any, type: any, which: any) => {

        if (which == 'buy') {
            let newArr = _.cloneDeep(buyList)
            if (type == 'total_amount') {
                newArr[index][type] = el.target.value
                // 计算订单总价

            } else {
                newArr[index][type] = el
            }

            newArr[index]['total'] = newArr[index]['item_latest_price'] * newArr[index]['count']
            setBuyList(newArr)
        }

        if (which == 'give') {
            let newArr = _.cloneDeep(giveList)
            newArr[index][type] = el
            newArr[index]['total'] = newArr[index]['item_latest_price'] * newArr[index]['count']

            setGiveList(newArr)
        }

        if (which == 'extra') {
            let newArr = _.cloneDeep(extraList)
            newArr[index][type] = el
            newArr[index]['total'] = newArr[index]['item_latest_price'] * newArr[index]['count']

            setExtraList(newArr)
        }
    }

    // 查看套餐项目
    const queryPackageItem = (value: string) => {
        baseAxiosNoInfo('/chankang_center/item_package/detail', {
            params: {
                item_id: value
            }

        }).then((res: any) => {
            res && setPackageItemData(res.item_attribute_base)
        })

        setPackageItemVisible(true)
    }

    const handlePayNumChange = (e: any, attr: number) => {
        let r: any = _.cloneDeep(payNums)
        r[attr] = e

        setPayNums(r)
    }

    const handleActualPay = (e: any) => {
        formInfoRef.setFieldsValue({ actual_pay_amount: e })
    }

    const handlePayTypeChange = (e: any) => {
        let num = 0

        e.forEach((el: any) => {
            num += ((Number(payNums[el]) * 100) / 100) || 0
        })

        formInfoRef.setFieldsValue({
            actual_pay_amount: num
        })
    }

    const handleAddBuyList = (type: any) => {
        let data: any = [
            {
                chankang_item_type: undefined,
                item_latest_price: undefined,
                store_item_id: undefined,
                count: 1,
                total: 0
            }
        ]

        if (type == 'buy') {
            setBuyList([...buyList, ...data])
        }

        if (type == 'give') {
            setGiveList([...giveList, ...data])
        }

        if (type == "extra") {
            setExtraList([...extraList, ...data])
        }
    }

    const deleteBuyList = (index: any, which: any) => {
        if (which == 'buy') {
            let data = _.cloneDeep(buyList).filter((item: any, index1: any) => index1 !== index)
            setBuyList(data)
        }

        if (which == 'give') {
            let data = _.cloneDeep(giveList).filter((item: any, index1: any) => index1 !== index)
            setGiveList(data)
        }

        if (which == 'extra') {
            let data = _.cloneDeep(extraList).filter((item: any, index1: any) => index1 !== index)
            setExtraList(data)
        }
    }

    // 金额输入框小数点控制后两位
    const limitDecimals = (value: any) => {
        const reg = /^(\-)*(\d+)\.(\d\d).*$/;
        // 取数字
        const data = value.replace(/[^0-9.]/g, "")

        // 取小数点后两位
        return data.replace(reg, '$1$2.$3')
    }

    // 查询
    const handleCancel = () => {
        setCustomerVisible(false)
    }

    const searchVip = (e: React.FocusEvent<HTMLInputElement>) => {
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

        if (!reg.test(e.target.value)) {
            message.warning('请输入正确的手机号!')
            return false
        }

        baseAxiosNoInfo('/chankang_center/customer/is_exist', { params: { customer_phone: e.target.value } }).then((res: any) => {
            if (res && res.customer_id != null) {
                setUserData(res)
                setHasVip(true)

            } else {
                customerRef.setFieldsValue({ customer_phone: e.target.value })
                setHasVip(false)
            }
        })
    }

    const addCustomer = () => {
        setCustomerVisible(true)
    }

    const submitCustomer = (value: any) => {
        let data = {
            customer_name: value.customer_name,
            customer_phone: value.customer_phone,
            customer_source_id: value.customer_source_id,
            employee_id_adviser: value.employee_id_adviser,
            remark: value.remark,
        }

        baseAxiosComplete.post('/chankang_center/customer/add', data).then(res => {
            if (res) {
                setUserData(res.data)
                setCustomerVisible(false)
                setHasVip(true)
            }
        })
    }

    const handleSubmit = () => {

        if (userData.customer_id == '') {
            message.warning('请输入客户手机号!')
            return false
        }

        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!reg.test(vipInfoRef.getFieldValue('customer_phone'))) {
            message.warning('请输入正确的手机号!')
            return false
        }

        if (!buyList.length && !giveList.length && !extraList.length) {
            message.warning('请至少选择一个套餐项目!')
            return false
        }

        if (buyList.length) {
            let falg = true

            buyList.map((el: any) => {
                if (el.chankang_item_type == '' || el.item_latest_price == '' || el.store_item_id == '' || el.total == 0 || el.total_amount == '' || !el.total_amount) {
                    falg = false
                }
            })

            if (!falg) {
                message.warning('请正确填写产康购买必填项!')
                return false
            }
        }

        if (giveList.length) {
            let falg = true

            giveList.map((el: any) => {
                if (el.chankang_item_type == '' || el.item_latest_price == '' || el.store_item_id == '') {
                    falg = false
                }
            })

            if (!falg) {
                message.warning('请完成产康赠送数据填写!')
                return false
            }
        }

        if (extraList.length) {
            let falg = true

            extraList.map((el: any) => {
                if (el.chankang_item_type == '' || el.item_latest_price == '' || el.store_item_id == '') {
                    falg = false
                }
            })

            if (!falg) {
                message.warning('请完成月子额外赠送数据填写!')
                return false
            }
        }

        if (formData2.length == 0 && formData.length == 0) {
            message.error('签单人选项，产康顾问和产康师最少要有一个!')
            return false
        }

        let data = {
            order_id: params.id,
            store_id: storeId,
            employee_id_adviser: employeeIdAdviser,
            employee_id_recover: employeeIdRecover,
            customer_id: userData.customer_id,
            buy_item_list: buyList.filter(item => item.store_item_id != ''),
            gift_chankang_item_list: giveList.filter(item => item.store_item_id != ''),
            gift_yuezi_item_list: extraList.filter(item => item.store_item_id != ''),
            actually_deal_amount: totalPrices,
            pay_records: [],
            agreement_pic_list: '',
            pay_pic_list: '',
            deal_date: '',
            remark: formInfoRef.getFieldValue('remark'),
            employee_adviser_list: formData,
            employee_recover_list: formData2
        }

        if (buyList.length) {
            data.deal_date = formInfoRef.getFieldValue('deal_date').format('YYYY-MM-DD HH:mm:ss')

            // 处理支付方式
            if (formInfoRef.getFieldValue('pay_way')) {
                data.pay_records = formInfoRef.getFieldValue('pay_way').map((el: any) => {
                    return {
                        "pay_amount": payNums[el],
                        "pay_way": el
                    }
                })
            }
        }

        // if (formInfoRef.getFieldValue('agreementList').length) {
        //     data.agreement_pic_list = formInfoRef.getFieldValue('agreementList').map((item: any) => { return item.response.data[0] }).toString() || ''
        // }

        if (formInfoRef.getFieldValue('payList').length) {
            data.pay_pic_list = formInfoRef.getFieldValue('payList').map((item: any) => { return item.response.data[0] }).toString() || ''
        }

        axiosHandleEvent.post('/chankang_center/order_list/update', data).then(res => { })
    }

    const storeList = optionData.map((el: any) => (<Option value={el.store_id} key={el.store_id}  >{el.store_name}</Option>))
    const customersourceList = customersource.map((el: any) => (<Option value={el.source_id} key={el.source_id}  >{el.source_name}</Option>))

    const getAdviseEmployeeList = adviseEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))

    const getckSingleList = ckSingle.map((el: any) => (<Option value={el.store_item_id} key={el.store_item_id} tab={el.item_id} label={el.item_latest_price} >{el.store_item_name}</Option>))
    const getckMenuList = ckMenu.map((el: any) => (<Option value={el.store_item_id} key={el.store_item_id} tab={el.item_id} label={el.item_latest_price} >{el.store_item_name}</Option>))

    const [empList, setEmpList] = useState<any[]>([])
    const [empList2, setEmpList2] = useState<any[]>([])

    interface formRow {
        employee_id: string | undefined
        user_name: string | undefined
        results_proportion: number | undefined
    }

    let formRow: formRow = {
        employee_id: undefined,
        user_name: undefined,
        results_proportion: undefined
    }

    const [formData, setFormData] = useState<formRow[]>([])
    const [formData2, setFormData2] = useState<formRow[]>([])

    const addMoreRow = () => {
        setFormData([...formData, formRow])
    }

    const addMoreRow2 = () => {
        setFormData2([...formData2, formRow])
    }

    const deleteRow = (index: number) => {
        if (formData.length > 1) {
            let reciveD = _.cloneDeep(formData)
            reciveD.splice(index, 1)

            setFormData(reciveD)
        }
    }

    const deleteRow2 = (index: number) => {
        if (formData2.length > 1) {
            let reciveD = _.cloneDeep(formData2)
            reciveD.splice(index, 1)

            setFormData2(reciveD)
        }
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(formData)
        reciveD[index][attr] = value

        if (attr == 'employee_id') {
            empList.forEach(el => {
                if (el.employee_id == value) {
                    reciveD[index]['user_name'] = el.user_name
                }
            })
        }

        setFormData(reciveD)
    }

    const handleChange2 = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(formData2)
        reciveD[index][attr] = value

        if (attr == 'employee_id') {
            empList2.forEach(el => {
                if (el.employee_id == value) {
                    reciveD[index]['user_name'] = el.user_name
                }
            })
        }

        setFormData2(reciveD)
    }

    return (<div className="ck-order-list-add common-level2-edit">
        {/* 产康中心 -> 产康项目管理 -> 产康订单管理 -> 编辑 */}
        <div className="sections">
            <h2>编辑产康订单</h2>

            <div className="sections-content">
                <div className="common-main">
                    <Form {...formItemLayout} form={vipInfoRef}>
                        <Form.Item label="门店" required>
                            <Select style={{ width: 200 }} placeholder="选择门店" onChange={handleStore} value={defaultStoreName}>{storeList}</Select>
                        </Form.Item>

                        <Form.Item label="签单人" required wrapperCol={{ span: 10 }}>
                            <div className='employee_box2'>
                                {formData.map((el, index: number) => <Row gutter={8} justify="space-between" style={{ marginBottom: 8, userSelect: 'none', maxWidth: 600 }}>
                                    <Col span={10}>
                                        <Select placeholder="产康顾问" style={{ width: '100%' }} value={el.employee_id} onChange={(v: any) => {
                                            handleChange(index, 'employee_id', v)
                                        }}>
                                            {adviseEmployeeList.map((el) => <Option value={el.employee_id}>{el.user_name}</Option>)}
                                        </Select>
                                    </Col>

                                    <Col span={10}>
                                        <Input placeholder='分配比例' style={{ width: '100%' }} value={el.results_proportion} type="number" onChange={(v: any) => {
                                            handleChange(index, 'results_proportion', v.target.value)
                                        }} />
                                    </Col>

                                    <Col span={4} style={{ paddingTop: 4 }}>
                                        <DeleteOutlined onClick={() => {
                                            deleteRow(index)
                                        }} style={{ cursor: 'pointer' }} />
                                    </Col>
                                </Row>)}

                                <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加产康顾问</Button>

                                <div className="line" style={{ marginTop: 20, marginBottom: 20, width: '100%', border: '1px dashed #999', height: 0 }}></div>

                                {formData2.map((el, index: number) => <Row gutter={8} justify="space-between" style={{ marginBottom: 8, userSelect: 'none', maxWidth: 600 }}>
                                    <Col span={10}>
                                        <Select placeholder="产康顾问" style={{ width: '100%' }} value={el.employee_id} onChange={(v: any) => {
                                            handleChange2(index, 'employee_id', v)
                                        }}>
                                            {recoverEmployeeList.map((el) => <Option value={el.employee_id}>{el.user_name}</Option>)}
                                        </Select>
                                    </Col>

                                    <Col span={10}>
                                        <Input placeholder='分配比例' style={{ width: '100%' }} value={el.results_proportion} type="number" onChange={(v: any) => {
                                            handleChange2(index, 'results_proportion', v.target.value)
                                        }} />
                                    </Col>

                                    <Col span={4} style={{ paddingTop: 4 }}>
                                        <DeleteOutlined onClick={() => {
                                            deleteRow2(index)
                                        }} style={{ cursor: 'pointer' }} />
                                    </Col>
                                </Row>)}

                                <Button onClick={addMoreRow2} style={{ marginTop: 16 }} size="small" type="primary">添加产康师</Button>

                                <div style={{ marginTop: 20 }}><span style={{ color: 'red' }}>注*</span> 产康顾问、产康师，必须选择其一或全选！</div>
                            </div>
                        </Form.Item>

                        <Form.Item label="客户手机号" name="customer_phone">
                            <Space>
                                <Input style={{ width: 200 }} placeholder="请输入手机号" value={userData.customer_phone} onBlur={searchVip} />
                                {!hasVip && hasVip !== null ? <div>
                                    <span style={{ color: 'red' }}>*</span> 该客户不存在!<br />
                                    <span style={{ color: '#1890ff', paddingLeft: '20px', cursor: 'pointer' }} onClick={addCustomer}>新增客户</span>
                                </div> : null}
                            </Space>
                        </Form.Item>

                        <Form.Item label="客户姓名" name="customer_name">
                            {userData?.customer_name ? userData?.customer_name : '--'}
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>

        <div className="sections">
            <h2 style={{ display: 'flex', alignItems: 'center' }}>产康购买
                <div style={{ fontSize: '24', color: '#1890ff', paddingLeft: '20px', cursor: 'pointer' }} onClick={() => { handleAddBuyList('buy') }}>添加</div>
            </h2>

            <div style={{ paddingLeft: '50px', paddingBottom: '20px', display: buyList.length ? '' : 'none' }}>
                <Row gutter={0} className="title" style={{ marginBottom: '10px' }}>
                    <Col span="3"><span className='must'>项目类型</span></Col>
                    <Col span="5"><span className='must'>项目名称</span></Col>
                    <Col span="3">项目明细</Col>
                    <Col span="3"><span className='must'>项目单价</span></Col>
                    <Col span="3"><span className='must'>项目次数</span></Col>
                    <Col span="3"><span className='must'>金额(元)</span></Col>
                    <Col span="3">删除</Col>
                </Row>

                {buyList.map((el: any, index: number) => (<Row key={index} style={{ height: '50px', lineHeight: '50px' }}>
                    <Col span="3">
                        <Select placeholder="选择类型" value={el.chankang_item_type} onChange={(el: any) => { handleSelectProject(el, index, 'chankang_item_type', 'buy') }}>
                            <Option value="1">产康单项</Option>
                            <Option value="2">产康套餐</Option>
                        </Select>
                    </Col>

                    <Col span="5">
                        <Select style={{ width: 240 }} showSearch filterOption={(input, option) =>
                            (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                        } placeholder="选择项目" value={el.store_item_id} onChange={(el: any, option: any) => { handleSelectStore(el, index, option, 'store_item_id', 'buy') }}>
                            {el.chankang_item_type == 1 && getckSingleList}
                            {el.chankang_item_type == 2 && getckMenuList}
                        </Select>
                    </Col>
                    <Col span="3">
                        {el.chankang_item_type == 2 && <Button onClick={() => {
                            queryPackageItem(el.item_id)
                        }} size="small" >查看</Button>}
                    </Col>
                    <Col span="3"><Input disabled placeholder="项目单价" value={el.item_latest_price} style={{ width: 100 }} /></Col>
                    <Col span="3"><InputNumber min={1} max={50} placeholder="项目次数" value={el.count} onChange={(el: any) => { handleCount(el, index, 'count', 'buy') }} /></Col>
                    <Col span="3" ><Input placeholder="金额" value={el.total_amount} style={{ width: 100 }} onChange={(el: any) => { handleCount(el, index, 'total_amount', 'buy') }} /></Col>
                    <Col span="3"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteBuyList(index, 'buy') }} /></Col>
                </Row>))}
            </div>
        </div>

        <div className="sections">
            <h2 style={{ display: 'flex', alignItems: 'center' }}>产康赠送
                <div style={{ fontSize: '24', color: '#1890ff', paddingLeft: '20px', cursor: 'pointer' }} onClick={() => { handleAddBuyList('give') }}>添加</div>
            </h2>

            <div style={{ paddingLeft: '50px', paddingBottom: '20px', display: giveList.length ? '' : 'none' }}>
                <Row gutter={0} className="title" style={{ marginBottom: '10px' }}>
                    <Col span="3"><span className='must'>项目类型</span></Col>
                    <Col span="5"><span className='must'>项目名称</span></Col>
                    <Col span="3">项目明细</Col>
                    <Col span="3"><span className='must'>项目单价</span></Col>
                    <Col span="3"><span className='must'>项目次数</span></Col>
                    <Col span="3">删除</Col>
                </Row>

                {giveList.map((el: any, index: number) => (<Row key={index} style={{ height: '50px', lineHeight: '50px' }}>
                    <Col span="3">
                        <Select style={{ width: 120 }} placeholder="选择类型" value={el.chankang_item_type} onChange={(el: any) => { handleSelectProject(el, index, 'chankang_item_type', 'give') }}>
                            <Option value="1">产康单项</Option>
                            <Option value="2">产康套餐</Option>
                        </Select>
                    </Col>
                    <Col span="5">
                        <Select style={{ width: 240 }} showSearch filterOption={(input, option) =>
                            (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                        } placeholder="选择项目" value={el.store_item_id} onChange={(el: any, option: any) => { handleSelectStore(el, index, option, 'store_item_id', 'give') }}>
                            {el.chankang_item_type == 1 && getckSingleList}
                            {el.chankang_item_type == 2 && getckMenuList}
                        </Select>
                    </Col>
                    <Col span="3">
                        {el.chankang_item_type == 2 && <Button onClick={() => {
                            queryPackageItem(el.item_id)
                        }} size="small" >查看</Button>}
                    </Col>
                    <Col span="3"><Input disabled placeholder="项目单价" value={el.item_latest_price} style={{ width: 100 }} /></Col>
                    <Col span="3"><InputNumber min={1} max={50} placeholder="项目次数" value={el.count} style={{ width: 100 }} onChange={(el: any) => { handleCount(el, index, 'count', 'give') }} /></Col>
                    <Col span="3"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteBuyList(index, 'give') }} /></Col>
                </Row>))}
            </div>
        </div>

        <div className="sections">
            <h2 style={{ display: 'flex', alignItems: 'center' }}>月子赠送
                <div style={{ fontSize: '24', color: '#1890ff', paddingLeft: '20px', cursor: 'pointer' }} onClick={() => { handleAddBuyList('extra') }}>添加</div>
            </h2>

            <div style={{ paddingLeft: '50px', paddingBottom: '20px', display: extraList.length ? '' : 'none' }}>
                <Row gutter={0} className="title" style={{ marginBottom: '10px' }}>
                    <Col span="3"><span className='must'>项目类型</span></Col>
                    <Col span="5"><span className='must'>项目名称</span></Col>
                    <Col span="3">项目明细</Col>
                    <Col span="3"><span className='must'>项目单价</span></Col>
                    <Col span="3"><span className='must'>项目次数</span></Col>
                    <Col span="3">删除</Col>
                </Row>

                {extraList.map((el: any, index: number) => (<Row key={index} style={{ height: '50px', lineHeight: '50px' }}>
                    <Col span="3">
                        <Select style={{ width: 120 }} placeholder="选择类型" value={el.chankang_item_type} onChange={(el: any) => { handleSelectProject(el, index, 'chankang_item_type', 'extra') }}>
                            <Option value="1">产康单项</Option>
                            <Option value="2">产康套餐</Option>
                        </Select>
                    </Col>
                    <Col span="5">
                        <Select showSearch filterOption={(input, option) =>
                            (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                        } style={{ width: 240 }} placeholder="选择项目" value={el.store_item_id} onChange={(el: any, option: any) => { handleSelectStore(el, index, option, 'store_item_id', 'extra') }}>
                            {el.chankang_item_type == 1 && getckSingleList}
                            {el.chankang_item_type == 2 && getckMenuList}
                        </Select>
                    </Col>
                    <Col span="3">
                        {el.chankang_item_type == 2 && <Button onClick={() => {
                            queryPackageItem(el.item_id)
                        }} size="small" >查看</Button>}
                    </Col>
                    <Col span="3"><Input disabled placeholder="项目单价" value={el.item_latest_price} style={{ width: 100 }} /></Col>
                    <Col span="3"><InputNumber min={1} max={50} placeholder="项目次数" value={el.count} style={{ width: 100 }} onChange={(el: any) => { handleCount(el, index, 'count', 'extra') }} /></Col>
                    <Col span="4"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteBuyList(index, 'extra') }} /></Col>
                </Row>))}
            </div>
        </div>

        <div className="sections" style={{ display: buyList.length ? '' : 'none' }}>
            <h2>订单结算</h2>

            <div className="sections-content">
                <Form labelCol={{ span: 3 }} wrapperCol={{ span: 3 }} form={formRef}>
                    <Form.Item label="订单金额" >
                        <Input placeholder="" disabled value={totalPrices} />
                    </Form.Item>

                    <Form.Item label="成交金额" required>
                        <InputNumber style={{ width: '100%' }} disabled value={totalPrices} onChange={((el: any) => { setShouldPay(el) })} formatter={limitDecimals} placeholder="请填写成交金额" />
                    </Form.Item>
                </Form>
            </div>
        </div>

        <div className="sections" >
            <h2>付款信息</h2>

            <div className="sections-content">
                <Form labelCol={{ span: 3 }} wrapperCol={{ span: 20 }} form={formInfoRef} onFinish={handleSubmit}>
                    {buyList.length != 0 && <Form.Item label="付款方式" name="pay_way" rules={[{ required: true, message: '必须选择付款方式' }]}>
                        <Checkbox.Group onChange={handlePayTypeChange} >
                            <Checkbox value={3} style={{ marginTop: 5 }}><Space><img src={wx} />微信<InputNumber type="number" style={{ width: 110 }} value={payNums['3']} onChange={(e: any) => { handlePayNumChange(e, 3) }} formatter={limitDecimals} /></Space></Checkbox>
                            <Checkbox value={2} style={{ marginTop: 5 }}><Space><img src={zfb} />支付宝<InputNumber type="number" style={{ width: 110 }} value={payNums['2']} onChange={(e: any) => { handlePayNumChange(e, 2) }} formatter={limitDecimals} /></Space></Checkbox>
                            <Checkbox value={4} style={{ marginTop: 5 }}><Space><img src={money} />POS机<InputNumber type="number" style={{ width: 110 }} value={payNums['4']} onChange={(e: any) => { handlePayNumChange(e, 4) }} formatter={limitDecimals} /></Space></Checkbox>
                            <Checkbox value={1} style={{ marginTop: 5 }}><Space><img src={pos} />现金<InputNumber type="number" style={{ width: 110 }} value={payNums['1']} onChange={(e: any) => { handlePayNumChange(e, 1) }} formatter={limitDecimals} /></Space></Checkbox>
                            <Checkbox value={5} style={{ marginTop: 5 }}><Space>月子转入<InputNumber type="number" style={{ width: 110 }} value={payNums['5']} onChange={(e: any) => { handlePayNumChange(e, 5) }} formatter={limitDecimals} /></Space></Checkbox>
                        </Checkbox.Group>
                    </Form.Item>}

                    {buyList.length != 0 && <Form.Item label="付款金额" name="actual_pay_amount">
                        <InputNumber placeholder="请输入付款金额" onChange={(e: any) => { handleActualPay(e) }} style={{ width: 200 }} formatter={limitDecimals} disabled />
                    </Form.Item>}

                    {buyList.length != 0 && <Form.Item label="付款时间" name="deal_date" rules={[{ required: true, message: '必须选择付款时间' }]}>
                        <DatePicker placeholder="请输入付款时间" style={{ width: 200 }} />
                    </Form.Item>}

                    <Form.Item
                        label="收款凭证"
                        valuePropName="fileList"
                        getValueFromEvent={uploadFile}
                        name="payList"
                        extra="（最多可上传6张，大小不超过2M）"
                        rules={[{ required: true, message: '必须上传图片' }]}
                    >
                        <Upload
                            name="files"
                            onPreview={handlePreview}
                            data={{ fileType: 1, bucketType: 4 }}
                            action={apiPrefix + '/global/upload_pic'}
                            listType="picture-card"
                            fileList={payList}
                        >
                            {uploadButton}
                        </Upload>
                    </Form.Item>

                    <Form.Item label="备注" name="remark">
                        <Input.TextArea placeholder="" />
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 3 }}>
                        <Space>
                            <Button type="primary" htmlType="submit">提交</Button>
                            <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>
        </div>

        <Modal title='新增客户' visible={customerVisible} onCancel={handleCancel} footer={false} width="600px">
            <Form {...customerFormItemLayout} form={customerRef} onFinish={submitCustomer}>
                <Form.Item label="客户姓名" name="customer_name" rules={[{ required: true, message: '请填写客户姓名' }]} >
                    <Input placeholder="" />
                </Form.Item>

                <Form.Item label="客户手机号" name="customer_phone" rules={[{ required: true, message: '请填写客户手机号' }]} >
                    <Input placeholder="" disabled />
                </Form.Item>

                <Form.Item label="客户来源" name="customer_source_id" rules={[{ required: true, message: '请选择客户来源' }]} >
                    <Select placeholder="选择客户来源">
                        {customersourceList}
                    </Select>
                </Form.Item>

                <Form.Item label="产康顾问" name="employee_id_adviser" rules={[{ required: true, message: '请选择产康顾问' }]} >
                    <Select placeholder="选择产康顾问">
                        {getAdviseEmployeeList}
                    </Select>
                </Form.Item>

                <Form.Item label="备注" name="remark" >
                    <Input.TextArea placeholder="" />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        {/* 项目明细弹窗 */}
        <Modal title="项目明细" visible={packageItemVisible} footer={false} onCancel={() => { setPackageItemVisible(false) }} width={500}>
            <div style={{ margin: '5px' }}>
                <Table pagination={false} dataSource={packageItemData} scroll={{ x: 'max-content' }} bordered={true} rowKey="id">
                    <Column title="项目名称" dataIndex="item_name" key="item_name" />
                    <Column title="项目次数" dataIndex="standard_times" key="standard_times" />
                </Table>
            </div>
        </Modal>

        <Modal visible={visible} title='浏览图片' footer={null} onCancel={() => { setVisible(false) }} >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
    </div>)
}